import { EActionCategory } from "@kuika/kuika-cl-model";

/**
 * One glyph per action category, for the action picker's category rows.
 * Icons live in `public/images/common`; a category not listed falls back to
 * `ACTION_CATEGORY_DEFAULT_ICON`. The third-party integrations have no brand glyphs in the kit, so
 * they share the generic API one (Google has its own).
 */
export const ACTION_CATEGORY_ICON_NAMES: Partial<Record<EActionCategory, string>> = {
  [EActionCategory.Other]: "dots",
  [EActionCategory.Advanced]: "adjustments-horizontal",
  [EActionCategory.Custom]: "settings-automation",
  [EActionCategory.Device]: "device-tablet",
  [EActionCategory.Export]: "file-export",
  [EActionCategory.Geolocation]: "map-pin-pin",
  [EActionCategory.Navigation]: "arrow-guide",
  [EActionCategory.Notification]: "bell",
  [EActionCategory.UIControl]: "click",
  [EActionCategory.Arithmetic]: "math-symbols",
  [EActionCategory.Authorization]: "shield",
  [EActionCategory.LocalStorage]: "file-database",
  [EActionCategory.MultiLanguage]: "world-www",
  [EActionCategory.Condition]: "git-branch",
  [EActionCategory.ProcessAutomation]: "automation",
  [EActionCategory.Trigger]: "bolt",
  [EActionCategory.Payment]: "credit-card",
  [EActionCategory.Invers]: "repeat",
  [EActionCategory.ManagedDb]: "server",
  [EActionCategory.StringOperations]: "text-size",
  [EActionCategory.ArrayOperations]: "list-numbers",
  [EActionCategory.ProcessAdministration]: "settings",
  [EActionCategory.RoboticProcessAutomation]: "ai-bot",
  [EActionCategory.OfflineDatabase]: "wifi-off",
  [EActionCategory.PivotTable]: "table",
  [EActionCategory.Mqtt]: "wifi",
  [EActionCategory.VectorSearch]: "database-search",
  [EActionCategory.Verification]: "checks",
  [EActionCategory.Bag]: "package",
  [EActionCategory.EAV]: "field",
  [EActionCategory.Cache]: "stack-2",
  [EActionCategory.Vision]: "scan-eye",
  [EActionCategory.Google]: "google",
  [EActionCategory.DocumentManagement]: "file-description",
  [EActionCategory.SearchEngine]: "list-search",
  [EActionCategory.BraveSearch]: "api",
  [EActionCategory.Dropbox]: "api",
  [EActionCategory.Github]: "api",
  [EActionCategory.Jira]: "api",
  [EActionCategory.Slack]: "api",
  [EActionCategory.Youtube]: "api",
  [EActionCategory.Airbnb]: "api",
  [EActionCategory.Trello]: "api",
  [EActionCategory.Office365]: "api"
};

export const ACTION_CATEGORY_DEFAULT_ICON: string = "apps";

export const getActionCategoryIconName = (category: EActionCategory | undefined): string =>
  (category === undefined ? undefined : ACTION_CATEGORY_ICON_NAMES[category]) ?? ACTION_CATEGORY_DEFAULT_ICON;
